import { DotsFilledIcon } from '@approvalmax/ui';
import { Button, Dropdown, Grid, Label, Menu, Text } from '@approvalmax/ui/src/components';
import { domHelpers, intl } from '@approvalmax/utils';
import { useSetAtom } from 'jotai';
import { type ComponentType, memo, type MemoExoticComponent, useCallback, useMemo } from 'react';
import { t } from 'services/localization';
import { /* convertCurrencyPopupState, */ fundWalletPopupState } from 'shared/components/(wallets)';
import { getCountryCodeByCurrency, getCountryFlagByCountryCode } from 'shared/helpers/(wallets)';

import { Loading } from './WalletCard.loading';
import { ChildrenComponents, WalletCardProps } from './WalletCard.types';

export const WalletCard = memo<WalletCardProps>((props) => {
    const { companyId, id: currency, balance, wallet } = props;

    const setFundWalletPopup = useSetAtom(fundWalletPopupState);
    // const setConvertCurrencyPopup = useSetAtom(convertCurrencyPopupState);
    const qa = domHelpers.generateDataQa(currency, 'wallet-card');
    const IconFlag = useMemo(() => getCountryFlagByCountryCode(getCountryCodeByCurrency(currency)), [currency]);

    const handleFund = useCallback(() => {
        setFundWalletPopup({
            companyId,
            currencyCode: wallet.currency,
            walletId: wallet.id,
        });
    }, [companyId, setFundWalletPopup, wallet.currency, wallet.id]);

    // const handleConvert = useCallback(() => {
    //     setConvertCurrencyPopup({
    //         isOpen: true,
    //         fromDefaultCurrency: currency,
    //         companyId,
    //     });
    // }, [companyId, currency, setConvertCurrencyPopup]);

    return (
        <Grid gap={8} gridTemplateColumns='max-content auto max-content'>
            {IconFlag && <IconFlag width='22px' height='16px' />}

            <div>
                <Label>{t('wallet_currency', { currency })}</Label>

                <Text font='label' fontSize='small'>
                    {intl.formatNumber(balance)}
                </Text>
            </div>

            {/* Since we might have no menu items, it's better to hide menu
             completely for such wallet cards. This is a temporary solution until we have
             some stable logic for menu items */}
            {wallet.isFundable && (
                <Dropdown
                    width='max-content'
                    activator={
                        <Button icon noPadding variant='text' data-qa={domHelpers.generateDataQa(qa, 'controls')}>
                            <DotsFilledIcon size={24} />
                        </Button>
                    }
                >
                    <Menu divider size='small'>
                        {wallet.isFundable && (
                            <Menu.Item
                                name={t('fund')}
                                data-qa={domHelpers.generateDataQa(qa, 'add-fund')}
                                onClick={handleFund}
                            />
                        )}

                        {/* Temporary hidden because not yet needed */}
                        {/* <Menu.Item
                        name={t('convert')}
                        data-qa={domHelpers.generateDataQa(qa, 'add-convert')}
                        onClick={handleConvert}
                    /> */}
                    </Menu>
                </Dropdown>
            )}
        </Grid>
    );
}) as MemoExoticComponent<ComponentType<WalletCardProps>> & ChildrenComponents;

WalletCard.displayName = 'WalletCard';
WalletCard.Loading = Loading;
